import {
  merge as mergeOptions
} from './qiniu/options'

export default {
  options: {
    qiniu: {}
  },
  install(Vue, options = {}) {
    let opts = Object.assign({}, this.options, options)

    // 安装qiniu，可选
    if (opts.qiniu !== false) {
      mergeOptions(opts.qiniu)
    }
  }
}



// WEBPACK FOOTER //
// ./src/packages/third/index.js